import { fontExtraBold, maxZIndex } from '../../style/styled-components/cssGlobalVariables';
import { styled } from '../ThemeConfigConnector/ThemeConfigConnnector';

export const ConfigErrorWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(19, 19, 32, 0.95);
    overflow: auto;
    z-index: ${maxZIndex + 5};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 24px;
`;

export const ConfigErrorTitle = styled.p`
    font-family: ${fontExtraBold};
    font-size: 32px;
    line-height: 40px;
    color: var(--color-dark-body);
    white-space: normal;
    margin-bottom: 16px;
`;

export const ConfigErrorBody = styled.p`
    color: var(--color-dark-body);
    margin-bottom: 32px;
    white-space: normal;
`;
